import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Form,
    Container,
    Row,
    Col,
} from "react-bootstrap";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";
import useGetData from "../../hooks/useGetData";
import { AppCheckBox } from "@dcam/dcam_flhealth_component_library";
import * as Yup from "yup";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";



interface LocationModalProps {
    show: boolean;
    onHide: () => void;
    onSave: (data: {
        email: string;
        routinizedFacilityName?: string;
        address?: string;
        city?: string;
        countyId?: string;
        stateId?: number;
        zipCode?: string;
        isActive?:boolean;
    }) => void;
    data?: {
        email: string;
        routinizedFacilityName?: string;
        address?: string;
        city?: string;
        countyId?: string;
        stateId?: number;
        zipCode?: string;
        isActive?:boolean;
    };
}
interface SelectOption {
    id: string;
    value: string;
  }
const LocationModal: React.FC<LocationModalProps> = ({ show, onHide, onSave,data }) => {
    const [email, setEmail] = useState("");
    const [routinizedFacilityName, setLocationName] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [countyId, setCountyId] = useState("");
    const [stateId, setStateId] = useState(10);
    const [zipCode, setZipCode] = useState("");
    const [isActive, setActive] = useState(false);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});


    
    const [states, setStates] = useState<SelectOption[]>([]);
    const [counties, setCounties] = useState<SelectOption[]>([]);

const { getDataById: getCounties } = useGetData<SelectOption[], string>(
    "Client/Counties",
    "GET"
  );
  const { getDataById: getStates } = useGetData<SelectOption[], string>(
    "Client/States",
    "GET"
  );
    useEffect(() => {
        if (data) {
            setEmail(data.email || "");
            setLocationName(data?.routinizedFacilityName || "");
            setAddress(data.address || "");
            setCity(data.city || "");
            setCountyId(data.countyId || "");
            setStateId(data.stateId || 10);
            setZipCode(data.zipCode || "");
            setActive(data.isActive || false);
        }
        const fetchStatesAndCounties = async () => {
            const stateData = await getStates(""); // Replace with actual API call
            const countyData = await getCounties(""); // Replace with actual API call
            setStates(stateData || []);
            setCounties(countyData || []);
          };
      
          fetchStatesAndCounties();
    }, [data]);

    const handleSave = () => {
        if (!validateFields()) return;

        onSave({ email, routinizedFacilityName, address, city, countyId, stateId, zipCode,isActive });
        onHide();
    };

    const handleClearFields = () => {
        setLocationName("");
        setAddress("");
        setCity("");
        setCountyId("");
        setStateId(10);
        setZipCode("");
        setActive(false);
    };


    const handleHide = () => {
        handleClearFields();
        onHide();
    };

    const validateFields = () => {
        let tempErrors: { [key: string]: string } = {};
        if (!routinizedFacilityName.trim()) tempErrors.routinizedFacilityName = "Location Name is required.";
        if (!address.trim()) tempErrors.address = "Address is required.";
        if (!city.trim()) tempErrors.city = "City is required.";
        if (!countyId) tempErrors.countyId = "County is required.";
        if (!zipCode.trim()) tempErrors.zipCode = "Zip Code is required.";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    return (
        <Modal show={show} onHide={handleHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Location Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <AppCard>
                        <div className="row mb-4">
                            <Row className="mb-4">
                                <Col>
                                    <AppLabel label="Location Name" required />
                                    <Form.Control
                                        type="text"
                                        value={routinizedFacilityName}
                                        onChange={(e) => setLocationName(e.target.value)}
                                        placeholder="Enter Location"
                                        isInvalid={!!errors.routinizedFacilityName}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.routinizedFacilityName}</Form.Control.Feedback>
                                </Col>

                            </Row>
                            <Row className="mb-4">
                                <Col style={{display:"flex"}}>
                                    
                                    <Form.Check
                                       
                                       checked={isActive}
                                        onChange={(e) => setActive(e.target.checked)}
                                       
                                    />  &nbsp;&nbsp;
                                    <AppLabel label="Active" required />
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col>
                                    <AppLabel label="Address" required />
                                    <Form.Control
                                        type="text"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Enter Street address"
                                        isInvalid={!!errors.address}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col>
                                    <AppLabel label="City" required />
                                    <Form.Control
                                        type="text"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        placeholder="Enter City"
                                        isInvalid={!!errors.city}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.city}</Form.Control.Feedback>
                                </Col>
                                <Col>
                                    <AppLabel label="County" required />
                                    <Form.Select onChange={(e)=>setCountyId(e.target.value)} value={countyId} isInvalid={!!errors.countyId}>
                                      <option value={0}>Select County</option>
                                      {counties.map((cnt) => (
                                        <option key={cnt.id} value={Number(cnt.id)}>
                                          {cnt.value}
                                        </option>
                                      ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">{errors.countyId}</Form.Control.Feedback>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col>
                                    <AppLabel label="State" required />
                                    <Form.Select
                                    value={10}  // Florida=10
                                      disabled //={!fieldsEnabled}
                                    >
                                      <option value={0}>Choose State...</option>
                                      {states.map((st) => (
                                        <option key={st.id} value={Number(st.id)}>
                                          {st.value}
                                        </option>
                                      ))}
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <AppLabel label="Zip Code" required />
                                    <Form.Control
                                        type="text"
                                        value={zipCode}
                                        onChange={(e) => setZipCode(e.target.value)}
                                        placeholder="Enter Zip Code"
                                        isInvalid={!!errors.zipCode}
                                        maxLength={5}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.zipCode}</Form.Control.Feedback>
                                </Col>
                            </Row>
                        </div>
                    </AppCard>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <AppButton variant="secondary" onClick={onHide}>
                    Cancel
                </AppButton>
                <AppButton variant="primary" type="button" onClick={handleSave}>
                    Save
                </AppButton>
            </Modal.Footer>
        </Modal>
    );
};

export default LocationModal;
